import { createProvider } from '@frontend/store';

type WeaveActionBarStore = {
  hasDot: boolean;
  actionsWithDot: {
    [key: string]: boolean;
  };
  removeActionsWithDot: (id: string) => void;
  setActionsWithDot: (id: string, value: boolean) => void;
};

export const { Provider: WeaveActionBarProvider, useStore: useWeaveActionBar } = createProvider<WeaveActionBarStore>()(
  (set, get) => ({
    hasDot: false,
    actionsWithDot: {},
    setActionsWithDot: (id: string, value: boolean) => {
      set((state) => ({
        ...state,
        actionsWithDot: {
          ...state.actionsWithDot,
          [id]: value,
        },
      }));

      const showDot = Object.values({
        ...get().actionsWithDot,
        [id]: value,
      }).some((val) => val === true);

      set({
        hasDot: showDot,
      });
    },

    removeActionsWithDot: (id: string) => {
      set((state) => {
        const { [id]: _, ...rest } = state.actionsWithDot;
        const showDot = Object.values(rest).some((val) => val === true);
        return {
          actionsWithDot: rest,
          hasDot: showDot,
        };
      });
    },
  })
);
